import { render, staticRenderFns } from "./UserProfileDialog.vue?vue&type=template&id=7084567f"
import script from "./UserProfileDialog.vue?vue&type=script&lang=ts"
export * from "./UserProfileDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports